export default __webpack_public_path__ + "static/media/not_available_dark.ac9f41e0.png";